import { useEffect, useState } from 'react';

/**
 * True below `md` (768px) — slice 84b.
 *
 * matchMedia-driven so only ONE render branch is ever in the DOM. A CSS
 * `hidden`/`md:hidden` pair would leave BOTH the table and the card list in the
 * document (jsdom and screen readers apply no CSS), duplicating every row — the
 * same multiple-elements trap the shell's single-nav invariant guards against,
 * and exactly what broke 40 row-query tests the first time this slice used CSS
 * display classes. Guarded for jsdom (no `matchMedia`) → defaults to desktop, so
 * the existing table-based tests keep rendering the table.
 *
 * Mirrors GlobalLive's local phone check (`max-width: 767px`), kept here as the
 * shared hook the data routes use.
 */
export function useIsMobile(query = '(max-width: 767px)'): boolean {
  const read = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;
  const [mobile, setMobile] = useState(read);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const on = () => setMobile(mql.matches);
    on();
    mql.addEventListener?.('change', on);
    return () => mql.removeEventListener?.('change', on);
  }, [query]);
  return mobile;
}
